export default import.meta.ROLLUP_FILE_URL_qCHaAofc_qR0fDx6kJ4jcQ